var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25px",
  height: "14px",
  viewBox: "0 0 25 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "FCE55F8D-ACBA-4BAA-AE35-A8D399FDFD81@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Schools/Web-SinglePlayer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Schools/Lessons/SEL",
  transform: "translate(-1062.000000, -354.000000)",
  stroke: "#010b3b",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "choose-content",
  transform: "translate(757.500000, 333.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Combined-Shape",
  transform: "translate(305.000000, 15.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.905947029,6.22806276 L11.8839888,17.8156791 M22.8839888,6.22806276 L11.905947,17.8156791"
})))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down.d774cf092c016652dea9def3c3a29b3c.svg";